<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0 p-5" style="    margin: 1vw .9vw;">
        <div class="d-flex justify-content-between">
          <h3>
            5M / تعاریف پایه / {{ name_route }}
          </h3>
          <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>

        </div>
        <hr class="mb-3">
        <div class="d-flex  justify-content-center align-items-center">
          <div class="d-flex col-8">
            <div class="col-lg-4 mb-3">
              <label class="form-label required">عنوان  متغیر {{ name_route }} </label>
              <textarea v-model="title" name="" id="" class="form-control" cols="30" rows="10"></textarea>
            </div>
            <div class="col-lg-4 mx-2">
              <button v-if="!is_update" @click.prevent="store" class="btn btn-primary btn-submit-1" style="transform: translateY(2vw)">ذخیره</button>
              <button v-else @click.prevent="update(item_id)" class="btn btn-primary btn-submit-1" style="transform: translateY(2vw)">ویرایش</button>
              <Reset v-if="is_update" @click.prevent="reset" style="width: 1.7vw; height: 1.7vw; transform: translateX(3vw)" />
            </div>
          </div>
          <p @click.prevent="info_release=true" class="btn btn-submit-1 btn-primary bg-success border-success" style="width: auto; padding: 0.5vw; margin-top: 1.5vw;">متغیرهای  پیش فرض {{name_route}} </p>

        </div>
        <hr class="mb-3">
        <center v-if="items.length">
          <table style="width: 50vw;"  class="table table-striped">
            <thead>
            <tr>
              <th style="width: 1vw;">ردیف</th>
              <th>عنوان متغیر</th>
              <th style="width: 8vw;">معیارها   </th>
              <th>عملیات</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in items" >
              <td scope="row">{{index+1}}</td>
              <td class="text-end">{{ item['name'] }}</td>
              <td>
                <button @click.prevent="Vars(item.id, item.name)" class="btn btn-primary btn-submit-1 w-100">تکمیل | بروزرسانی</button>
              </td>
              <td style="width: 6vw;">
                <a @click.prevent="edit(item['id'], item.name)" href="#"><img class="table-edit-img"
                                                                                                                          src="../../../../assets/img/pen.svg" alt="edit"></a>
                &nbsp;
                <a @click.prevent="deleteItem(item['id'])" href="#"><img class="table-delete-img mr-1"
                                                                                                                                src="../../../../assets/img/delete.svg"
                                                                                                                                alt="delete"></a>
              </td>
            </tr>

            </tbody>
          </table>
        </center>
        <center v-else>
          <p><span>{{name_route}}</span><span> یافت نشد.</span></p>
        </center>
        <hr class="mb-3 mt-3">
        <div class="d-flex justify-content-between">
          <p @click.prevent="back" class="btn btn-submit-1 btn-primary">مرحله قبلی</p>
          <p @click.prevent="next" class="btn btn-submit-1 btn-primary">مرحله بعدی</p>
        </div>
      </div>

    </div>
  </div>
  <div class="modal__error" v-if="info_release" dir="rtl">
    <div>
      <p>اخطار</p>
      <p @click="info_release=!info_release">❌</p>
    </div>
    <div>
      <p class="bg-white rounded p-2 text-end">آیا شما میخواهید سوالات پیش فرض {{name_route}} را وارد کنید؟</p>
      <button @click="releaseQ">تایید</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(item_id)">تایید</button>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="modal_var" style="z-index: 999999999999999; width: 42vw;">
    <div>
      <p> {{name_route}} / {{name_var}}</p>
      <p @click="modal_var=!modal_var">❌</p>
    </div>
    <div>
     <div class="bg-white p-2 rounded w-100">
       <div class="d-flex  justify-content-center">
         <div class="w-auto mb-3">
           <label class="form-label required">عنوان معیار  متغیر {{ name_var }} </label>
           <textarea v-model="title_var" name="" id="" class="form-control" cols="30" rows="10"></textarea>
         </div>
         <div class="col-lg-4 mx-2">
           <button v-if="!is_update_var" @click.prevent="store_var" class="btn btn-primary btn-submit-1" style="transform: translateY(2vw)">ذخیره</button>
           <button v-else @click.prevent="update_var(item_id_var)" class="btn btn-primary btn-submit-1" style="transform: translateY(2vw)">ویرایش</button>
           <Reset v-if="is_update_var" @click.prevent="reset_var" style="width: 1.7vw; height: 1.7vw; transform: translateX(3vw)" />
         </div>
       </div>
       <hr class="mt-2 mb-2">
      <center v-if="items_vars.length" class="overflow-scroll" style="height: 20vw;">
        <table style="width: 37vw;"  class="table table-striped">
          <thead>
          <tr>
            <th class="sticky-header" style="width: 1vw;">ردیف</th>
            <th class="sticky-header">عنوان معیار  {{ name_var }}</th>
            <th class="sticky-header">عملیات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in items_vars" >
            <td scope="row">{{index+1}}</td>
            <td class="text-end">{{ item['name'] }}</td>

            <td style="width: 6vw;">
              <a @click.prevent="edit_var(item['id'], item.name)" href="#"><img class="table-edit-img"
                                                                            src="../../../../assets/img/pen.svg" alt="edit"></a>
              &nbsp;
              <a @click.prevent="deleteItem_var(item['id'])" href="#"><img class="table-delete-img mr-1"
                                                                       src="../../../../assets/img/delete.svg"
                                                                       alt="delete"></a>
            </td>
          </tr>

          </tbody>
        </table>
      </center>
       <center v-else>
        معیاری برای   {{name_var}} یافت نشد.
       </center>

     </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="modal_var=!modal_var" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(item_id)">تایید</button>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal_var" style="z-index: 99999999999999999999999999999 !important">
    <div>
      <p>حذف</p>
      <p @click="deleteModal_var=!deleteModal_var">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal_var=!deleteModal_var" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm_var(item_id_var)">تایید</button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";
import Reset from "@/components/Icons/Reset.vue";
import cookies from "vue-cookies";
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  name: 'HomeView',
  components: {
    Reset,
    Sidebar,
    splash
  },
  data() {
    return {
      deleteModal_var: false,
      deleteModal: false,
      info_release: false,
      modal_var: false,
      is_update: false,
      is_update_var: false,
      counter: 1,
      name_route: '',
      title: '',
      items: [],
      items_vars: [],
      item_id: '',
      item_id_var: '',
      name_var: '',
      id_var: '',
      title_var: '',
    }
  },
  methods: {
    deleteItem_var(id){
      this.deleteModal_var = true
      this.item_id_var = id
    },
    edit_var(id,name){
      this.item_id_var = id
      this.title_var = name
      this.is_update_var = true
    },
    Vars(id,name){
      this.name_var = name
      this.id_var = id
      this.modal_var = true
      this.all_var(this.id_var)


    },

    deleteItemForm_var(id){
      fetch(`${this.base_url}/CriteriaPestel/destroy/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },


      }).then(response => response.json())
          .then((response) => {
            if (response.error){
              toast.error(response.error)
              return
            }
            if (response.message){
              toast.success(response.message)
              this.all_var(this.id_var)
              this.info_release = false
              this.deleteModal_var = false
              this.reset()
            }

          }).catch((err) => {
        // console.log(err)
      })
    },
    deleteItemForm(id){
      fetch(`${this.base_url}/PestelVariables/destroy/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },


      }).then(response => response.json())
          .then((response) => {
            if (response.error){
              toast.error(response.error)
              return
            }
            if (response.message){
              toast.success(response.message)
              this.all()
              this.info_release = false
              this.deleteModal = false
              this.reset()
            }

          }).catch((err) => {
        // console.log(err)
      })
    },
    update_var(id){
      if(!this.title_var.length){
        toast.error('عنوان اجباری است!')
        return;
      }
      fetch(`${this.base_url}/CriteriaPestel/update/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'name': this.title_var,
        }),

      }).then(response => response.json())
          .then((response) => {
            if (response.error){
              toast.error(response.error)
              return
            }
            if (response.message){
              toast.success(response.message)
              this.all_var(this.id_var)
              this.info_release = false
              this.is_update_var = false
              this.reset_var()
            }

          }).catch((err) => {
        // console.log(err)
      })
    },
    update(id){
      if(!this.title.length){
        toast.error('عنوان اجباری است!')
        return;
      }
      fetch(`${this.base_url}/PestelVariables/update/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'name': this.title,
        }),

      }).then(response => response.json())
          .then((response) => {
            if (response.error){
              toast.error(response.error)
              return
            }
            if (response.message){
              toast.success(response.message)
              this.all()
              this.info_release = false
              this.reset()
            }

          }).catch((err) => {
        // console.log(err)
      })
    },
    edit(id,name){
      this.item_id = id
      this.title = name
      this.is_update = true
    },
    deleteItem(id){
      this.item_id = id
      this.deleteModal = true

    },
    releaseQ(){
      fetch(`${this.base_url}/PestelVariables/default_questions_store/${this.counter}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },

      }).then(response => response.json())
          .then((response) => {
            if (response.error){
              toast.error(response.error)
              return
            }
            if (response.message){
              toast.success(response.message)
              this.all()
              this.info_release = false
            }

          }).catch((err) => {
        // console.log(err)
      })
    },

    store(){
      if(!this.title.length){
        toast.error('عنوان اجباری است!')
        return;
      }
      fetch(`${this.base_url}/PestelVariables/store`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'name': this.title,
          'type': this.counter,
        }),
      }).then(response => response.json())
          .then((response) => {
            if (response.error){
              toast.error(response.error)
              return
            }
            if (response.message){
              toast.success(response.message)
              this.all()
            }
      }).catch((err) => {
        // console.log(err)
      })
    },
    store_var(){
      if(!this.title_var.length){
        toast.error('عنوان اجباری است!')
        return;
      }
      fetch(`${this.base_url}/store_item`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'name': this.title_var,
          'variable_id': this.id_var,
        }),
      }).then(response => response.json())
          .then((response) => {
            if (response.error){
              toast.error(response.error)
              return
            }
            if (response.message){
              toast.success(response.message)
              this.all_var(this.id_var)
              this.title_var = ''
            }
          }).catch((err) => {
        // console.log(err)
      })
    },
    reset(){
      this.item_id = ''
      this.title = ''
      this.is_update = false
    },
    reset_var(){
      this.item_id_var = ''
      this.title_var = ''
      this.is_update_var = false
    },
    next() {
      if (this.counter===5) {
        router.push('/Internal_environment_analysis_5m_step_two')
       return;
      }
      this.counter++
      this.getName()



    },
    back() {
      if (this.counter===1) {
       router.push('/pestel')
        return;
      }
      this.counter--
      this.getName()


    },
     getName() {
      if (this.counter === 1) {
        this.name_route = 'نیرو انسانی (man)'
      } else if (this.counter === 2) {
        this.name_route = 'تجهیزات ( Machine )'
      } else if (this.counter === 3) {
        this.name_route = 'مواد و ملزومات (material )'
      } else if (this.counter === 4) {
        this.name_route = 'روش ها و رویه ها ( mechanism  )'
      } else if (this.counter === 5) {
        this.name_route = 'مدیریت (management )'
      }
      this.all()

    },
    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
        return
      }

    },
    all() {
      fetch(`${this.base_url}/PestelVariables`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'type': this.counter,
        }),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.all){
              this.items.length=0
              this.items = [...response.all]
            }

          }).catch((err) => {
      })
    },
    all_var(id) {
      fetch(`${this.base_url}/CriteriaPestel/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'type': this.counter,
        }),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.all){
              this.items_vars.length=0
              this.items_vars = [...response.all]
            }

          }).catch((err) => {
      })
    },
  },
  mounted() {
    this.checkIsMother()
    this.all()
    this.getName()
  }
}
</script>
<style scoped lang="scss">
a {
  font-size: 1vw;
}

/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/

h3 {
  font-size: 1.3vw !important;
}

small, span {
  font-size: 1vw !important;
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 2;
}
</style>